import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import type * as React from 'react'

import type { CostRevenueType } from '../../types'

interface CostRevenueSelectorProps {
  value: CostRevenueType
  onChange: (value: CostRevenueType) => void
}

/**
 * A reusable selector for toggling between Cost and Revenue
 */
export function CostRevenueSelector({ value, onChange }: CostRevenueSelectorProps) {
  return (
    <Horizontal flex='0' style={{ overflow: 'visible' }} verticalCenter gap={8}>
      <Texto style={{ whiteSpace: 'nowrap' }} appearance='hint'>
        Cost/Revenue:
      </Texto>
      <Select
        size='small'
        value={value}
        onChange={onChange}
        style={{ width: 120 }}
        options={[
          { value: 'Cost', label: 'Cost' },
          { value: 'Revenue', label: 'Revenue' },
        ]}
      />
    </Horizontal>
  )
}
